<template>
	<div>
		this is plugin compontent name is aa
	</div>
</template>

<script>
	export default{
		name:"aa"
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/lib/index.vue